<template>
  <div class="pagination-section">
    <div class="pagination-arrows" v-if="showArrows">
      <div :class="['arrow previous', { disabled: pagination.current_page === 1 }]"
           :data-page="previousPage"
           @click="changePage(previousPage)"></div>
      <div :class="['arrow next',{ disabled: pagination.current_page === pagination.total_pages }]"
           :data-page="nextPage"
           @click="changePage(nextPage)"></div>
    </div>
    <div class="pagination-dots">
      <span v-for="page in pagination.total_pages"
            :key="page"
            :id="page"
            :class="['page', { selected: pagination.current_page === page, ['show-dots']: rangeWithDots ? rangeWithDots.includes(page) : true }]"
            @click="changePage(page)"
            :data-page="page">
        {{ page }}
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      numberOfDots: {
        default: 7,
        type: [Number, String],
      },
      pagination: Object,
      showArrows: Boolean,
    },

    data() {
      return {
        paginationRange: null,
        rangeWithDots: null,
      };
    },

    methods: {
      changePage(page) {
        event.stopPropagation()
        if (this.pagination.current_page !== page) {
          this.setRangeWithDots(page)
          this.$emit('changePage', page);
        }
      },

      initPagination() {
        const totalPages = this.pagination.total_pages
        this.paginationRange = Array.from({length: totalPages}, (v, k) => k+1)
        if (totalPages > this.numberOfDots) { this.rangeWithDots = this.paginationRange.slice(0, this.numberOfDots) }
      },

      setRangeWithDots(page) {
        if (!this.rangeWithDots) { return; }
        const firstDotRange = this.rangeWithDots[0],
          lastDotRange = this.rangeWithDots[this.rangeWithDots.length - 1],
          moveLeft = page < firstDotRange,
          moveRight =  page > lastDotRange

        let beginning,
          end

        if (moveLeft) {
          end = page
          beginning = (end - this.numberOfDots) < 0 ? 0 : (end - this.numberOfDots)
          return this.rangeWithDots = this.paginationRange.slice(beginning, end)
        }

        if (moveRight) {
          beginning = (page - 1) < 0 ? 0 : page - 1
          end = beginning + this.numberOfDots
          return this.rangeWithDots = this.paginationRange.slice(beginning, end)
        }
      },
    },

    created() {
      this.initPagination()
    },

    computed: {
      nextPage: function () {
        const next = parseInt(this.pagination.current_page) + 1
        if (next > this.pagination.total_pages) {
          return this.pagination.total_pages
        } else {
          return next
        }
      },

      previousPage: function () {
        const previous = parseInt(this.pagination.current_page) - 1
        if (previous < 1) {
          return 1
        } else {
          return previous
        }
      }
    },

  }
</script>